<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Produktfamilie C6100">
     Produktfamilie C6100
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_de" title="Sicherheitshinweise">
     Sicherheitshinweise
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href="safety.html#d0e23" title="Konventionen">
      Konventionen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_de" title="Informationen zum Drucker">
     Informationen zum Drucker
    </a>
   </p>
   <div id="divd0e187">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_de" title="Ermitteln von Druckerinformationen">
      Ermitteln von Druckerinformationen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_de" title="Auswahl eines Druckerstandorts">
      Auswahl eines Druckerstandorts
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configured-models-topic.html#configured-models_de" title="Druckerkonfigurationen">
      Druckerkonfigurationen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_de" title="Anschlie&szlig;en von Kabeln">
      Anschlie&szlig;en von Kabeln
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_de" title="Verwenden des Bedienfelds">
      Verwenden des Bedienfelds
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-power-button-and-indicator-light-topic.html#understanding-status-power-button-and-indicator-light_de" title="Erl&auml;uterungen zum Status der Netztaste und der Kontrollleuchte">
      Erl&auml;uterungen zum Status der Netztaste und der Kontrollleuchte
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_de" title="Verwenden des Startbildschirms">
      Verwenden des Startbildschirms
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-map-sfp-topic.html#menus-map-sfp_de" title="Men&uuml;zuordnung">
      Men&uuml;zuordnung
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_de" title="Drucken einer Men&uuml;einstellungsseite">
      Drucken einer Men&uuml;einstellungsseite
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_de" title="Unzul&auml;ssige Papiersorten">
      Unzul&auml;ssige Papiersorten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_de" title="Verwenden von Recycling-Papier">
      Verwenden von Recycling-Papier
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_de" title="Einrichten und Verwenden der Startbildschirm-Anwendungen">
     Einrichten und Verwenden der Startbildschirm-Anwendungen
    </a>
   </p>
   <div id="divd0e1162">
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_de" title="Anpassen des Startbildschirms">
      Anpassen des Startbildschirms
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#using-display-customization_de" title="Verwenden der Anzeigenanpassung">
      Verwenden der Anzeigenanpassung
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-forms-and-favorites-topic.html#setting-up-forms-and-favorites_de" title="Einrichten von Formularen und Favoriten">
      Einrichten von Formularen und Favoriten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-eco-settings-topic.html#configuring-eco-settings_de" title="Konfigurieren der Spareinstellungen">
      Konfigurieren der Spareinstellungen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-customer-support-topic.html#using-customer-support_de" title="Verwendung von Customer Support">
      Verwendung von Customer Support
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-qr-code-generator-topic.html#using-qr-code-generator_de" title="Verwenden des QR-Codegenerators">
      Verwenden des QR-Codegenerators
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas_de" title='"Ger&auml;tekontingente" einrichten'>
      "Ger&auml;tekontingente" einrichten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-google-drive-topic.html#using-google-drive_de" title="Mit Google Drive">
      Mit Google Drive
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-contacts-topic.html#d0e1391" title="Verwalten von Kontakten">
      Verwalten von Kontakten
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-accessibility-features-chapter.html#setting-up-using-accessibility-features-chapter_de" title="Einrichten und Verwenden der Barrierefreiheitsfunktionen">
     Einrichten und Verwenden der Barrierefreiheitsfunktionen
    </a>
   </p>
   <div id="divd0e1510">
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_de" title="Aktivieren des Vergr&ouml;&szlig;erungsmodus">
      Aktivieren des Vergr&ouml;&szlig;erungsmodus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance_de" title="Sprachsteuerung wird aktiviert">
      Sprachsteuerung wird aktiviert
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_de" title="Anpassen der Sprechgeschwindigkeit f&uuml;r die Sprachsteuerung">
      Anpassen der Sprechgeschwindigkeit f&uuml;r die Sprachsteuerung
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_de" title="Aktivieren der gesprochen Kennw&ouml;rter oder pers&ouml;nlichen Identifikationsnummern">
      Aktivieren der gesprochen Kennw&ouml;rter oder pers&ouml;nlichen Identifikationsnummern
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures_de" title="Navigieren auf dem Bildschirm mit Gesten">
      Navigieren auf dem Bildschirm mit Gesten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display_de" title="Verwenden der Tastatur auf dem Display">
      Verwenden der Tastatur auf dem Display
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_de" title="Einlegen von Papier und Spezialdruckmedien">
     Einlegen von Papier und Spezialdruckmedien
    </a>
   </p>
   <div id="divd0e1713">
    <p class="toc-2-style">
     <a href="setting-paper-size-type-topic.html#setting-paper-size-type_de" title="Festlegen des Formats und derselben Sorte der Spezialdruckmedien">
      Festlegen des Formats und derselben Sorte der Spezialdruckmedien
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-m-topic.html#configuring-universal-paper-settings-m_de" title='Konfigurieren des Papierformats "Universal"'>
      Konfigurieren des Papierformats "Universal"
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_de" title="Laden der F&auml;cher">
      Laden der F&auml;cher
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_de" title="Einlegen von Druckmedien in die Universalzuf&uuml;hrung">
      Einlegen von Druckmedien in die Universalzuf&uuml;hrung
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_de" title="Verbinden von F&auml;chern">
      Verbinden von F&auml;chern
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_de" title="Drucken">
     Drucken
    </a>
   </p>
   <div id="divd0e1900">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_de" title="Von einem Computer aus drucken">
      Von einem Computer aus drucken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-forms-topic.html#printing-forms_de" title="Drucken von Formularen">
      Drucken von Formularen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e1952" title="Drucken &uuml;ber ein Mobilger&auml;t">
      Drucken &uuml;ber ein Mobilger&auml;t
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-h2-topic.html#printing-from-flash-drive-h2_de" title="Drucken von einem Flash-Laufwerk">
      Drucken von einem Flash-Laufwerk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_de" title="Unterst&uuml;tzte Flash-Laufwerke und Dateitypen">
      Unterst&uuml;tzte Flash-Laufwerke und Dateitypen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_de" title="Konfigurieren vertraulicher Druckauftr&auml;ge">
      Konfigurieren vertraulicher Druckauftr&auml;ge
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-h-topic.html#printing-confidential-and-other-held-jobs-h_de" title="Drucken angehaltener Auftr&auml;ge">
      Drucken angehaltener Auftr&auml;ge
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_de" title="Drucken von Schriftartmusterlisten">
      Drucken von Schriftartmusterlisten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_de" title="Abbrechen eines Druckauftrags">
      Abbrechen eines Druckauftrags
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_de" title="Sichern des Druckers">
     Sichern des Druckers
    </a>
   </p>
   <div id="divd0e2345">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_de" title="Ermitteln des Sicherheitssteckplatzes">
      Ermitteln des Sicherheitssteckplatzes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_de" title="L&ouml;schen des Druckerspeichers">
      L&ouml;schen des Druckerspeichers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory_de" title="L&ouml;schen des Druckerfestplattenspeichers">
      L&ouml;schen des Druckerfestplattenspeichers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-printer-hard-disk-encryption-topic.html#configuring-printer-hard-disk-encryption_de" title="Konfigurieren der Verschl&uuml;sselung der Festplatte">
      Konfigurieren der Verschl&uuml;sselung der Festplatte
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_de" title="Wiederherstellen der Werksvorgaben">
      Wiederherstellen der Werksvorgaben
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_de" title="Hinweis zu fl&uuml;chtigem Speicher">
      Hinweis zu fl&uuml;chtigem Speicher
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_de" title="Wartung des Druckers">
     Wartung des Druckers
    </a>
   </p>
   <div id="divd0e2558">
    <p class="toc-2-style">
     <a href="adjusting-default-internal-speaker-volume-topic.html#d0e2563" title="Anpassen der Lautsprecherlautst&auml;rke">
      Anpassen der Lautsprecherlautst&auml;rke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-using-printer-control-panel-topic.html#d0e2655" title="Arbeiten im Netzwerk">
      Arbeiten im Netzwerk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_de" title="Einrichten des seriellen Drucks (nur Windows)">
      Einrichten des seriellen Drucks (nur Windows)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_de" title="Reinigen des Druckers">
      Reinigen des Druckers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_de" title="Bestellen von Druckerverbrauchsmaterial und -teilen">
      Bestellen von Druckerverbrauchsmaterial und -teilen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-developer-unit-topic.html#d0e3222" title="Ersetzen von Druckerverbrauchsmaterial und -teilen">
      Ersetzen von Druckerverbrauchsmaterial und -teilen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="storing-supplies-topic.html#storing-supplies_de" title="Aufbewahren von Verbrauchsmaterial">
      Aufbewahren von Verbrauchsmaterial
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e3692" title="Umstellen des Druckers">
      Umstellen des Druckers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e3749" title="Sparen von Energie und Papier">
      Sparen von Energie und Papier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e3888" title="Recycling-Papier">
      Recycling-Papier
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_de" title="Beseitigen von Staus">
     Beseitigen von Staus
    </a>
   </p>
   <div id="divd0e3942">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_de" title="Vermeiden von Papierstaus">
      Vermeiden von Papierstaus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_de" title="Erkennen von Papierstaubereichen">
      Erkennen von Papierstaubereichen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-trays-topic.html#jam-in-trays_de" title="Papierstau in F&auml;chern">
      Papierstau in F&auml;chern
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jams-in-mpf-topic.html#jams-in-mpf_de" title="Papierstau in der Universalzuf&uuml;hrung">
      Papierstau in der Universalzuf&uuml;hrung
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-standard-bin-topic.html#jam-in-standard-bin_de" title="Papierstau im Standardfach">
      Papierstau im Standardfach
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-door-b-topic.html#jam-in-door-b_de" title="Papierstau in Klappe&nbsp;B">
      Papierstau in Klappe&nbsp;B
     </a>
    </p>
    <p class="toc-2-style">
     <a href="jam-in-finisher-bin-topic.html#jam-in-finisher-bin_de" title="Papierstau in der Finisher-Ablage">
      Papierstau in der Finisher-Ablage
     </a>
    </p>
    <p class="toc-2-style">
     <a href="staple-jam-door-g-topic.html#staple-jam-door-g_de" title="Heftklammerstau in Klappe&nbsp;G">
      Heftklammerstau in Klappe&nbsp;G
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_de" title="Fehlerbehebung">
     Fehlerbehebung
    </a>
   </p>
   <div id="divd0e4286">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e4289" title="Probleme mit der Netzwerkverbindung">
      Probleme mit der Netzwerkverbindung
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e4505" title="Hardwareoptionen, Probleme">
      Hardwareoptionen, Probleme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e4778" title="Probleme mit Zubeh&ouml;r">
      Probleme mit Zubeh&ouml;r
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_de" title="Probleme mit der Papierzufuhr">
      Probleme mit der Papierzufuhr
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_de" title="Druckerprobleme">
      Druckerprobleme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#d0e7331" title="Probleme mit der Farbqualit&auml;t">
      Probleme mit der Farbqualit&auml;t
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_de" title="Kontaktaufnahme mit dem Kundendienst">
      Kontaktaufnahme mit dem Kundendienst
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_de" title="Aktualisieren und Migrieren">
     Aktualisieren und Migrieren
    </a>
   </p>
   <div id="divd0e7568">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e7571" title="Hardware">
      Hardware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e7899" title="Software">
      Software
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e7976" title="Firmware">
      Firmware
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_de" title="Hinweise">
     Hinweise
    </a>
   </p>
   <div id="divd0e8046">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8049" title="Produktinformationen">
      Produktinformationen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8066" title="Hinweis zur Ausgabe">
      Hinweis zur Ausgabe
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_de" title="Marken">
      Marken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_de" title="Lizenzhinweise">
      Lizenzhinweise
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#hinweis-zum-gs-zeichen_de" title="Hinweis zum GS-Zeichen">
      Hinweis zum GS-Zeichen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_de" title="Ger&auml;uschemissionspegel">
      Ger&auml;uschemissionspegel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8206" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e8233" title="Lithium-Ionen-Akku">
      Lithium-Ionen-Akku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_de" title="Verordnung (EU) 2023/1542">
      Verordnung (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_de" title="R&uuml;ckgabe von Lexmark Kassetten zur Wiederverwendung oder zum Recycling">
      R&uuml;ckgabe von Lexmark Kassetten zur Wiederverwendung oder zum Recycling
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_de" title="Hinweis zur statischen Empfindlichkeit">
      Hinweis zur statischen Empfindlichkeit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_de" title="Temperaturinformationen">
      Temperaturinformationen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_de" title="Laser-Hinweis">
      Laser-Hinweis
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-advisory-label_de" title="Laser-Hinweisaufkleber">
      Laser-Hinweisaufkleber
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue